import { render, staticRenderFns } from "./TabPrices.vue?vue&type=template&id=c9ac6166"
import script from "./TabPrices.vue?vue&type=script&lang=js"
export * from "./TabPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports